import React from 'react';

export default function Footer() {
    return (
        <>
            <hr className="footer-sep" />
            <footer className="site-footer">
                <div className="footer-inner footer-columns">
                    <div className="footer-col contact-col">
                        <h4 className="footer-heading">අප අමතන්න</h4>

                        <div className="footer-contact-row">
                            <svg className="footer-contact-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                <circle cx="12" cy="9" r="2.2" fill="currentColor" />
                            </svg>
                            <div className="footer-contact-text">
                                <div>සබරගමුව පළාත් කෘෂිකර්ම දෙපාර්තමේන්තුව</div>
                                <div className="muted">මුවගම, රත්නපුර, ශ්‍රී ලංකාව</div>
                            </div>
                        </div>

                        <div className="footer-contact-row hotline-row">
                            <svg className="footer-contact-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2 4.18 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.72c.12.81.38 1.6.75 2.34a2 2 0 0 1-.45 2.11L8.91 9.91a16 16 0 0 0 6 6l1.74-1.74a2 2 0 0 1 2.11-.45c.74.37 1.53.63 2.34.75A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className="footer-contact-text">
                                <div className="hotline-label">Hotline</div>
                                <a className="hotline-number" href="tel:0706100404">0706100404</a>
                            </div>
                        </div>

                        <div className="footer-contact-row">
                            <svg className="footer-contact-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M3 8.5v7A2.5 2.5 0 0 0 5.5 18h13a2.5 2.5 0 0 0 2.5-2.5v-7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M21 6.5a2.5 2.5 0 0 0-2.5-2.5h-13A2.5 2.5 0 0 0 3 6.5v.42l9 5.25 9-5.25V6.5z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className="footer-contact-text">විදයුත් තැපෑල :<br />agrisabara@gmail.com</div>
                        </div>
                    </div>

                    <div className="footer-col links-col">
                        <h4 className="footer-heading">විශේෂ සබැදි</h4>
                        <ul className="footer-list">
                            <li><a href="https://agridept.sg.gov.lk" target="_blank" rel="noopener noreferrer">කෘෂිකර්ම දෙපාර්තමේන්තුව (සබරගමුව)</a></li>
                            <li><a href="https://www.sg.gov.lk" target="_blank" rel="noopener noreferrer">සබරගමුව පළාත් සභාව</a></li>
                            <li><a href="https://www.doa.gov.lk" target="_blank" rel="noopener noreferrer">කෘෂිකර්ම දෙපාර්තුමේන්තුව (ශ්‍රී ලංකා)</a></li>
                        </ul>
                    </div>

                    <div className="footer-col social-col">
                        <h4 className="footer-heading">සමාජ මාධ්‍ය</h4>
                        <div className="footer-social-links">
                            <a href="https://www.facebook.com/share/1Q9h8fB9AQ/" target="_blank" rel="noopener noreferrer" className="social-link facebook-link" aria-label="Follow us on Facebook">
                                <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                </svg>
                                <span>Facebook</span>
                            </a>
                            <a href="https://www.youtube.com/channel/UC1ZOmmgheDbNGdNSMuLzaeg" target="_blank" rel="noopener noreferrer" className="social-link youtube-link" aria-label="Follow us on YouTube">
                                <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                                </svg>
                                <span>Youtube</span>
                            </a>
                        </div>
                    </div>

                    <div className="footer-col map-col">
                        <h4 className="footer-heading">ස්ථානය</h4>
                        <div className="footer-map">
                            <iframe
                                title="Sabaragamuwa Province Department of Agriculture - Muwagama"
                                src="https://maps.google.com/maps?q=Provincial+Department+of+Agriculture+Sabaragamuwa+Muwagama&z=17&output=embed"
                                width="320"
                                height="180"
                                style={{ border: 0 }}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="footer-inner">
                        <p>© {new Date().getFullYear()} Department of Agriculture Sabaragamuwa Province<br /> B&B Web Solutions</p>
                    </div>
                </div>
            </footer>
        </>
    );
}
